module.exports = __webpack_public_path__ + "img/l.95e2f96d.jpg";